import data from './data.html';
import product from './product.html';

export {
    data,
    product,
};



// WEBPACK FOOTER //
// ./content/index.js